import * as React from "react";
const SvgNewFolder1 = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 2.813v19.314H22.13V6.557h-9.817L10.44 4.686 8.57 2.813H5.22ZM3.38 4.31h4.555L9.81 6.188l1.877 1.876h8.933v12.558H3.38v-8.157z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgNewFolder1;
